import { Country } from './country.model';

export class PostalCode {
    ID?: number
    COUNTRIES_ID?: number
    POSTAL_CODE?: string
    CREATED_BY?: string
    CREATED_DATE?: Date
    MODIFIED_BY?: string
    MODIFIED_DATE?: Date

    COUNTRy?: Country
}

